document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".product-tabs").forEach((tabs) => {

    const buttons = tabs.querySelectorAll(".product-tab-btn");
    const contents = tabs.querySelectorAll(".product-tab-content");

    buttons.forEach((button) => {

      button.addEventListener("click", function () {

        const target = this.dataset.tab;

        // Remove active class
        buttons.forEach((btn) => btn.classList.remove("active"));
        contents.forEach((content) => content.classList.remove("active"));

        // Add active class
        this.classList.add("active");

        const activeContent = tabs.querySelector("#" + target);

        if (activeContent) {
          activeContent.classList.add("active");
        }

      });

    });

  });

});

// Accessories Block

document.addEventListener('click', function (event) {

  const minusButton = event.target.closest(
    '.pdp-accessories-block [data-qty-minus]'
  );

  if (minusButton) {

    const card = minusButton.closest(
      '[data-accessory-card]'
    );

    if (!card) return;

    const input = card.querySelector(
      '.pdp-accessory-qty__input'
    );

    if (!input) return;

    let quantity =
      parseInt(input.value, 10) || 1;

    quantity = Math.max(
      1,
      quantity - 1
    );

    input.value = quantity;

    return;
  }

  const plusButton = event.target.closest(
    '.pdp-accessories-block [data-qty-plus]'
  );

  if (plusButton) {

    const card = plusButton.closest(
      '[data-accessory-card]'
    );

    if (!card) return;

    const input = card.querySelector(
      '.pdp-accessory-qty__input'
    );

    if (!input) return;

    let quantity =
      parseInt(input.value, 10) || 1;

    quantity++;

    input.value = quantity;

    return;
  }

  const addButton = event.target.closest(
    '.pdp-accessories-block [data-add-accessory]'
  );

  if (addButton) {

    event.preventDefault();

    addAccessoryProduct(addButton);

  }

});

async function addAccessoryProduct(button) {

  const card = button.closest(
    '[data-accessory-card]'
  );

  if (!card) return;


  const quantityInput = card.querySelector(
    '.pdp-accessory-qty__input'
  );

  const message = card.querySelector(
    '[data-accessory-message]'
  );


  const variantId = Number(
    button.dataset.variantId
  );


  if (!variantId) {
    return;
  }


  const quantity = Math.max(
    1,
    parseInt(quantityInput?.value, 10) || 1
  );


  const originalText =
    button.textContent.trim();


  button.disabled = true;
  button.textContent = 'Adding...';


  if (message) {

    message.textContent = '';

    message.classList.remove(
      'is-success',
      'is-error'
    );

  }


  try {

    const root =
      window.Shopify?.routes?.root || '/';


    const cartDrawer =
      document.querySelector('cart-drawer');

    let sections = [
      'cart-drawer',
      'cart-icon-bubble'
    ];


    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender === 'function'
    ) {

      sections =
        cartDrawer
          .getSectionsToRender()
          .map(section => section.id);

    }

    const response = await fetch(
      root + 'cart/add.js',
      {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({

          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ],

          sections: sections,

          sections_url:
            window.location.pathname

        })

      }
    );


    const result =
      await response.json();


    if (!response.ok) {

      throw new Error(
        result.description ||
        result.message ||
        'Unable to add accessory'
      );

    }

    if (
      cartDrawer &&
      typeof cartDrawer.renderContents === 'function'
    ) {

      cartDrawer.renderContents(result);

      requestAnimationFrame(() => {

        cartDrawer.classList.remove(
          'is-empty'
        );


        const drawerItems =
          cartDrawer.querySelector(
            'cart-drawer-items'
          );


        if (drawerItems) {

          drawerItems.classList.remove(
            'is-empty'
          );

        }

      });


    } else {

      updateAccessoryCartFallback(
        result
      );

    }

    if (quantityInput) {
      quantityInput.value = 1;
    }


    button.textContent = 'Added';


    if (message) {

      message.textContent =
        'Added to cart';

      message.classList.add(
        'is-success'
      );

    }


    setTimeout(() => {

      button.textContent =
        originalText;


      if (message) {

        message.textContent = '';

        message.classList.remove(
          'is-success'
        );

      }

    }, 1200);



  } catch (error) {

    console.error(
      'Accessory add error:',
      error
    );


    button.textContent =
      originalText;


    if (message) {

      message.textContent =
        error.message ||
        'Unable to add product';

      message.classList.add(
        'is-error'
      );

    }


  } finally {

    button.disabled = false;

  }

}

function updateAccessoryCartFallback(result) {

  if (!result.sections) {
    return;
  }

  if (
    result.sections['cart-icon-bubble']
  ) {

    const holder =
      document.createElement('div');


    holder.innerHTML =
      result.sections[
        'cart-icon-bubble'
      ];


    const newBubble =
      holder.querySelector(
        '#cart-icon-bubble'
      );


    const currentBubble =
      document.querySelector(
        '#cart-icon-bubble'
      );


    if (
      newBubble &&
      currentBubble
    ) {

      currentBubble.innerHTML =
        newBubble.innerHTML;

    }

  }

  if (
    result.sections['cart-drawer']
  ) {

    const holder =
      document.createElement('div');


    holder.innerHTML =
      result.sections['cart-drawer'];


    const newDrawer =
      holder.querySelector(
        'cart-drawer'
      );


    const currentDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      newDrawer &&
      currentDrawer
    ) {

      currentDrawer.innerHTML =
        newDrawer.innerHTML;

      currentDrawer.classList.remove(
        'is-empty'
      );

    }

  }
  requestAnimationFrame(() => {

    const drawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      drawer &&
      typeof drawer.open === 'function'
    ) {

      drawer.open();

    }

  });

}

// Profile Block

document.addEventListener('DOMContentLoaded', function () {

  initProfileSelectors();

});


document.addEventListener('shopify:section:load', function () {

  initProfileSelectors();

});


function initProfileSelectors() {

  document
    .querySelectorAll('[data-profile-selector]')
    .forEach(function (selector) {

      if (selector.dataset.profileInitialized === 'true') {
        return;
      }

      selector.dataset.profileInitialized = 'true';

      loadProfileImages(selector);

    });

}

async function loadProfileImages(selector) {

  const options = selector.querySelectorAll(
    '[data-profile-option]'
  );


  for (const option of options) {

    const type = option.dataset.profileType;

    if (!type) continue;

    try {

      const productData = await getFirstProductByType(type);

      if (
        !productData ||
        !productData.featured_image
      ) {
        continue;
      }


      const imageUrl =
        productData.featured_image;

      option.dataset.image = imageUrl;

      const imageWrapper = option.querySelector(
        '[data-profile-option-image-wrapper]'
      );

      if (!imageWrapper) continue;


      imageWrapper.innerHTML = '';


      const img = document.createElement('img');

      img.src = imageUrl;
      img.alt = type;
      img.width = 70;
      img.height = 70;
      img.loading = 'lazy';

      img.setAttribute(
        'data-profile-option-image',
        ''
      );


      imageWrapper.appendChild(img);


    } catch (error) {

      console.warn(
        'Profile image could not be loaded:',
        type,
        error
      );

    }

  }

}

async function getFirstProductByType(type) {

  const root =
    window.Shopify?.routes?.root || '/';

  const query =
    'product_type:"' +
    type.replace(/"/g, '\\"') +
    '"';


  const url =
    root +
    'search/suggest.json' +
    '?q=' +
    encodeURIComponent(query) +
    '&resources[type]=product' +
    '&resources[limit]=10' +
    '&resources[options][unavailable_products]=show';


  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  });


  if (!response.ok) {
    throw new Error(
      'Search request failed'
    );
  }


  const data =
    await response.json();


  const products =
    data?.resources?.results?.products || [];

  const exactProduct =
    products.find(function (item) {

      return (
        String(item.type || '')
          .trim()
          .toLowerCase()
        ===
        String(type)
          .trim()
          .toLowerCase()
      );

    });


  const firstProduct =
    exactProduct || products[0];


  if (!firstProduct) {
    return null;
  }

  let image = '';


  if (firstProduct.featured_image) {

    if (
      typeof firstProduct.featured_image === 'string'
    ) {

      image =
        firstProduct.featured_image;

    } else {

      image =
        firstProduct.featured_image.url ||
        firstProduct.featured_image.src ||
        '';

    }

  }


  if (!image && firstProduct.image) {

    if (
      typeof firstProduct.image === 'string'
    ) {

      image =
        firstProduct.image;

    } else {

      image =
        firstProduct.image.url ||
        firstProduct.image.src ||
        '';

    }

  }


  return {
    product: firstProduct,
    featured_image: image
  };

}

document.addEventListener('click', function (event) {

  const trigger =
    event.target.closest(
      '[data-profile-trigger]'
    );


  if (trigger) {

    const selector =
      trigger.closest(
        '[data-profile-selector]'
      );


    if (!selector) return;


    const menu =
      selector.querySelector(
        '[data-profile-menu]'
      );


    if (!menu) return;


    const isOpen =
      selector.classList.contains(
        'is-open'
      );

    document
      .querySelectorAll(
        '[data-profile-selector].is-open'
      )
      .forEach(function (otherSelector) {

        if (
          otherSelector === selector
        ) {
          return;
        }


        closeProfileSelector(
          otherSelector
        );

      });

    if (isOpen) {

      closeProfileSelector(
        selector
      );

    } else {

      selector.classList.add(
        'is-open'
      );

      menu.hidden = false;

      trigger.setAttribute(
        'aria-expanded',
        'true'
      );

    }


    return;

  }

  const option =
    event.target.closest(
      '[data-profile-option]'
    );


  if (option) {

    const selector =
      option.closest(
        '[data-profile-selector]'
      );


    if (!selector) return;


    const selectedText =
      selector.querySelector(
        '[data-profile-selected]'
      );


    const selectedImageWrapper =
      selector.querySelector(
        '[data-profile-image-wrapper]'
      );


    const hiddenInput =
      selector.querySelector(
        '[data-profile-input]'
      );


    const value =
      option.dataset.value || '';


    const imageUrl =
      option.dataset.image || '';

    if (selectedText) {

      selectedText.textContent =
        value;

    }

    if (
      selectedImageWrapper &&
      imageUrl
    ) {

      selectedImageWrapper.innerHTML =
        '';


      const selectedImage =
        document.createElement(
          'img'
        );


      selectedImage.src =
        imageUrl;

      selectedImage.alt =
        value;

      selectedImage.width =
        80;

      selectedImage.height =
        80;


      selectedImage.setAttribute(
        'data-profile-image',
        ''
      );


      selectedImageWrapper.appendChild(
        selectedImage
      );

    }

    if (hiddenInput) {

      hiddenInput.value =
        value;

    }

    selector
      .querySelectorAll(
        '[data-profile-option]'
      )
      .forEach(function (item) {

        item.classList.remove(
          'is-selected'
        );

      });


    option.classList.add(
      'is-selected'
    );


    /*
     * Close dropdown
     */
    closeProfileSelector(
      selector
    );


    return;

  }

  document
    .querySelectorAll(
      '[data-profile-selector].is-open'
    )
    .forEach(function (selector) {

      if (
        !selector.contains(
          event.target
        )
      ) {

        closeProfileSelector(
          selector
        );

      }

    });

});

function closeProfileSelector(selector) {

  selector.classList.remove(
    'is-open'
  );


  const menu =
    selector.querySelector(
      '[data-profile-menu]'
    );


  const trigger =
    selector.querySelector(
      '[data-profile-trigger]'
    );


  if (menu) {

    menu.hidden = true;

  }


  if (trigger) {

    trigger.setAttribute(
      'aria-expanded',
      'false'
    );

  }

}

// Cart Update
// document.addEventListener(
//   'click',
//   function (event) {

//     const quantityButton = event.target.closest(
//       'cart-items quantity-input .quantity__button'
//     );

//     if (!quantityButton) return;


//     const quantityInput = quantityButton
//       .closest('quantity-input')
//       ?.querySelector('.quantity__input');

//     if (!quantityInput) return;


//     const currentQuantity =
//       parseInt(quantityInput.value, 10) || 1;


//     /*
//      * Dawn / Shopify quantity rules
//      */
//     const minQuantity =
//       parseInt(quantityInput.dataset.min, 10) || 1;

//     const maxAttribute =
//       quantityInput.getAttribute('max');

//     const maxQuantity =
//       maxAttribute !== null
//         ? parseInt(maxAttribute, 10)
//         : null;


//     /*
//      * =====================================
//      * MINUS
//      * =====================================
//      */
//     if (quantityButton.name === 'minus') {

//       /*
//        * Quantity already minimum hai.
//        * Dawn ko event bhi mat do.
//        */
//       if (currentQuantity <= minQuantity) {

//         event.preventDefault();
//         event.stopImmediatePropagation();

//         quantityInput.value = minQuantity;

//         return;
//       }

//     }


//     /*
//      * =====================================
//      * PLUS
//      * =====================================
//      */
//     if (quantityButton.name === 'plus') {

//       /*
//        * Agar Shopify ne max diya hua hai
//        * aur already max tak pahunch gaye hain,
//        * click stop kar do.
//        */
//       if (
//         maxQuantity !== null &&
//         currentQuantity >= maxQuantity
//       ) {

//         event.preventDefault();
//         event.stopImmediatePropagation();

//         quantityInput.value = maxQuantity;

//         return;
//       }

//     }


//     /*
//      * IMPORTANT:
//      *
//      * Valid quantity hai to Dawn ka original
//      * quantity handler chalne do.
//      *
//      * Hum yahan preventDefault nahi karenge.
//      */

//   },
//   true
// );
